import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import SaveIcon from "@mui/icons-material/Save";

export interface IProps {
  /**
   * ボタンが押された場合に呼び出されます
   */
  onClick?: () => void;
}

export default function SaveButton(props: IProps) {
  const [open, setOpen] = useState(false);
  function handleMouseOver() {
    if (open === false) {
      setOpen(true);
    }
  }
  function handleMouseLeave() {
    if (open === true) {
      setOpen(false);
    }
  }
  return (
    <Tooltip title="save" arrow placement="bottom" open={open}>
      <IconButton
        aria-label="save"
        onClick={props.onClick}
        onMouseOver={handleMouseOver}
        onMouseLeave={handleMouseLeave}
      >
        <SaveIcon />
      </IconButton>
    </Tooltip>
  );
}
